import { render, staticRenderFns } from "./BusinessProfileCard.vue?vue&type=template&id=c5cc4672&scoped=true&"
import script from "./BusinessProfileCard.vue?vue&type=script&lang=js&"
export * from "./BusinessProfileCard.vue?vue&type=script&lang=js&"
import style0 from "./BusinessProfileCard.vue?vue&type=style&index=0&id=c5cc4672&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5cc4672",
  null
  
)

export default component.exports